import { ColumnDimension } from "@components/common/data-grid/adm-data-grid-types";
import {
  SEARCH_WORKSPACES_TABLE_COLUMN_LABELS,
  SearchWorkspacesTableColumnField,
  SearchWorkspacesTableGridColDef,
} from "@pages/home/search/search-tables/search-workspaces-tables/search-workspaces-table-types";
import {
  WorkspaceCreatedAtCell,
  WorkspaceMemberCountCell,
  WorkspaceNameCell,
  WorkspaceOptionCell,
  WorkspaceProjectCountCell,
} from "@utils/data-grid-utils/workspace-data-grid-cells";
import { useMemo } from "react";

const columnDimension: ColumnDimension<SearchWorkspacesTableColumnField> = {
  name: {
    flex: 1.5,
  },
  projects: {
    flex: 1.5,
  },
  members: {
    flex: 2.5,
  },
  createdAt: {
    flex: 1,
  },
  options: {
    flex: 1,
    maxWidth: 120,
  },
};

/**
 * @returns the columns definition to be used in the search workspaces table
 */
export function useSearchWorkspacesTableColumns(): SearchWorkspacesTableGridColDef[] {
  return useMemo(() => {
    const columnsMap: Record<
      SearchWorkspacesTableColumnField,
      SearchWorkspacesTableGridColDef
    > = {
      name: {
        field: "name",
        headerName: SEARCH_WORKSPACES_TABLE_COLUMN_LABELS.name,
        ...columnDimension.name,
        valueGetter: (_, row) => row.entity.name,
        renderCell: WorkspaceNameCell,
      },

      projects: {
        field: "projects",
        headerName: SEARCH_WORKSPACES_TABLE_COLUMN_LABELS.projects,
        ...columnDimension.projects,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.projectCount,
        renderCell: WorkspaceProjectCountCell,
      },

      members: {
        field: "members",
        headerName: SEARCH_WORKSPACES_TABLE_COLUMN_LABELS.members,
        ...columnDimension.members,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.memberCount,
        renderCell: WorkspaceMemberCountCell,
      },

      createdAt: {
        field: "createdAt",
        headerName: SEARCH_WORKSPACES_TABLE_COLUMN_LABELS.createdAt,
        ...columnDimension.createdAt,
        getApplyQuickFilterFn: () => null,
        valueGetter: (_, row) => row.entity.createdAt,
        renderCell: WorkspaceCreatedAtCell,
      },

      options: {
        field: "options",
        type: "actions",
        headerName: SEARCH_WORKSPACES_TABLE_COLUMN_LABELS.options,
        ...columnDimension.options,
        align: "right",
        renderCell: (params) =>
          WorkspaceOptionCell(params, "search-companies-table"),
      },
    };
    return Object.values(columnsMap);
  }, []);
}
